export const SEARCH_TERMS = ["title", "meta_title"];
export const inputFields = {
  course: {
    type: "string",
    required: true,
    title: "Course",
    inputType: "text",
  },
  subject: {
    type: "string",
    required: true,
    title: "Subject",
    inputType: "text",
  },
  date_of_exam: {
    type: "string",
    required: true,
    title: "Date Of Exam",
    inputType: "date",
  },
  time: {
    type: "string",
    required: true,
    title: "Time",
    inputType: "time",
  },
  exam_center: {
    type: "string",
    required: true,
    title: "Exam Center",
    inputType: "text",
  },
  city: {
    type: "string",
    required: true,
    title: "city",
    inputType: "text",
  },
  pincode: {
    type: "string",
    required: true,
    title: "pincode",
    inputType: "number",
  },

  exam_hours: {
    type: "string",
    required: true,
    title: "exam hours",
    inputType: "text",
  },
  medium_of_exam: {
    type: "string",
    required: true,
    title: "medium of exam",
    inputType: "text",
  },
  featured_image: {
    type: "file",
    required: false,
    title: "Upload College ID",
  },
  gallery: {
    type: "gallery",
    required: false,
    title: "Upload Date Sheet",
  },
};
export const initialValues = {
  course: "",
  subject: "",
  date_of_exam: "",
  time: "",
  exam_center: "",
  city: "",
  pincode: "",
  subject: "",
  exam_hours: "",
  medium_of_exam: "",
};

export const view_all_table = [
  { name: "course", value: "course" },
  { name: "Subject", value: "subject" },
  { name: "Date Of Exam", value: "date_of_exam" },
  { name: "Time", value: "time" },
  { name: "exam center", value: "exam_center" },
  { name: "City", value: "city" },
  { name: "Pincode", value: "pincode" },
  { name: "status", value: "status" },
];
